import { useCallback, useMemo } from 'react';
import { useSetAtom } from 'jotai';

import { useIsEmployerAnAdmin } from '@restworld/feature-authentication';
import { EmployerFlexibleSlotsCard, SkeletonEmployerCardLoading } from '@restworld/ui-ds';
import { useIsFreemiumUser } from '@restworld/utils-common';

import { computeSlotsInfo } from '../flexible-slots-v2';
import { useFlexibleSlotsQuery, useFlexibleSubscriptionSlotsQuery } from '../flexible-slots-v2/flexible-slots-v2.hooks';
import { useV2Router } from './hooks/use-v2-router';
import EmployerNoPermissionToBuySlotModal, {
  isEmployerNoPermissionToBuySlotModalOpenAtom,
} from '../employer-companies/modals/employer-no-permission-to-buy-slot-modal';

function DashboardFlexibleSlotsCard() {
  const router = useV2Router();
  const { data: flexibleSlots, isLoading: isFlexibleSlotsLoading } = useFlexibleSlotsQuery();
  const { data: subscriptionSlots, isLoading: isSubscriptionSlotsLoading } = useFlexibleSubscriptionSlotsQuery();
  const isAdmin = useIsEmployerAnAdmin();
  const setIsEmployerNoPermissionToBuySlotModalOpen = useSetAtom(isEmployerNoPermissionToBuySlotModalOpenAtom);
  const isFreemiumUser = useIsFreemiumUser();

  const { activeSlots, idleFlexibleSlotsLength } = useMemo(
    () => computeSlotsInfo(flexibleSlots, subscriptionSlots),
    [flexibleSlots, subscriptionSlots]
  );

  const handleClick = useCallback(
    () =>
      isFreemiumUser
        ? router.push('/employer/purchase')
        : isAdmin
        ? router.push('/employer/payments-and-invoices')
        : setIsEmployerNoPermissionToBuySlotModalOpen(true),
    [isAdmin, isFreemiumUser, router, setIsEmployerNoPermissionToBuySlotModalOpen]
  );

  if (isFlexibleSlotsLoading || isSubscriptionSlotsLoading) {
    return <SkeletonEmployerCardLoading />;
  }

  return (
    <>
      <EmployerFlexibleSlotsCard
        activeSlots={activeSlots}
        inactiveSlots={idleFlexibleSlotsLength}
        onManageClick={handleClick}
      />
      <EmployerNoPermissionToBuySlotModal />
    </>
  );
}

export default DashboardFlexibleSlotsCard;
